<template>
  <div class="btn" @click="handleClick" v-if="sty==1">
    {{name}}
  </div>
  <div class="btn" @click="handleClick" v-if="sty==2">
    {{name}}
  </div>
</template>

<script>
export default {
  name: 'MyButton',
  props: ['name','sty'],
  methods:{
    handleClick(){
      this.$emit('handleClick')
    }
  }
}
</script>

<style scoped lang="less">
  .btn{
    padding: .2rem 0;
    width: 2rem;
    text-align: center;
    color: #000;
    background: #fff;
    font-weight: bold;
    margin-bottom: .3rem;
    cursor: pointer;
  }
</style>